import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {
    GeneralForm: {},
    BusinessForm: {},
    IssuesAndNeedsForm: {}
}

const getters = {

}

const actions = {
    getRequirementForms ({ commit }, params) {
        return Service.Requirement.getRequirementForms(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getRequirementFormById ({ commit }, params) {
        return Service.Requirement.getRequirementFormById(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    createRequirementForm ({ commit }, data) {
        return Service.Requirement.createRequirementForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    saveRequirementForm ({ commit }, data) {
        return Service.Requirement.saveRequirementForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    editRequirementForm ({ commit }, data) {
        return Service.Requirement.editRequirementForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    updateRequirementForm ({ commit }, data) {
        return Service.Requirement.updateRequirementForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    deleteRequirementForm ({ commit }, data) {
        return Service.Requirement.deleteRequirementForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    }
}

const mutations = {
    setGeneralForm (state, val) {
        state.GeneralForm = val
    },

    setBusinessForm (state, val) {
        state.BusinessForm = val
    },

    setIssuesAndNeedsForm (state, val) {
        state.IssuesAndNeedsForm = val
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
